import type { UserPreferencesProvider } from '@atlaskit/editor-common/types';
import type { SelectionToolbarPluginOptions } from '@atlaskit/editor-plugin-selection-toolbar';
import { fg } from '@atlaskit/platform-feature-flags';

interface Props {
	options: {
		contextualFormattingEnabled: boolean;
	};
	providers: {
		userPreferencesProvider: UserPreferencesProvider | undefined;
	};
}

export function selectionToolbarPluginOptions({
	options,
	providers,
}: Props): SelectionToolbarPluginOptions {
	return {
		preferenceToolbarAboveSelection: false,
		contextualFormattingEnabled: fg('platform_hide_contextual_toolbar_for_embedded_page')
			? options.contextualFormattingEnabled
			: true,
		userPreferencesProvider: providers.userPreferencesProvider,
	};
}
